export default __webpack_public_path__ + "static/media/banner1.ae19dfe8.png";